import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CallConsoleScreen } from "../components/relations/CallConsoleScreen";

// Any call type id: built-in ones and the ones made with the wizard.
const callType = z.string().max(32);

const searchSchema = z.object({
  // A real call task to work (queue → console). When absent, `call` opens a
  // read-only script preview ("Try call" from the scripts library).
  task: z.string().optional(),
  call: callType.optional(),
  member: z.string().optional(),
});

export const Route = createFileRoute("/_auth/relations/console")({
  staticData: {
    titleKey: "relations.console.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  validateSearch: searchSchema,
  component: ConsoleRoute,
});

function ConsoleRoute() {
  const { task, call } = Route.useSearch();
  return <CallConsoleScreen taskId={task} call={call} />;
}
